module.exports = __webpack_public_path__ + "img/juegos.svg.0efa2269.webp";